import { render } from "./Customizer.vue?vue&type=template&id=0d6923a1&scoped=true"
import script from "./Customizer.vue?vue&type=script&lang=js"
export * from "./Customizer.vue?vue&type=script&lang=js"

import "./Customizer.vue?vue&type=style&index=0&id=0d6923a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6923a1"]])

export default __exports__